import React, { useState } from 'react';
import { HashLink } from 'react-router-hash-link';
import { useLocation } from 'react-router-dom';
import "../../style.css"
import { Helper } from '../../static/helper';

const NavLinks = ({ closeMenu }) => {
    const [openDropdown, setOpenDropdown] = useState(null);
    const location = useLocation();

    const webSite = () => {
        window.open(Helper.urlReservation)
    }

    const toggleDropdown = (name) => {
        setOpenDropdown(openDropdown === name ? null : name);
    }

    const handleLinkClick = () => {
        if (closeMenu) {
            closeMenu();
        }
        setOpenDropdown(null);
    }

    const isActive = (path) => {
        if (path === '/#Accueil') return location.pathname === '/';
        return location.pathname === path;
    }

    const linkClass = (path) => {
        const base = "px-4 font-extrabold transition-colors duration-200";
        // Mobile: dark text on white bg, Desktop: light text on dark bg
        return isActive(path)
            ? `${base} text-blue-900 lg:text-white`
            : `${base} text-gray-700 lg:text-gray-300 hover:text-blue-900 lg:hover:text-white`;
    }

    return (
        <>
            <HashLink className={linkClass('/#Accueil')} smooth to="/#Accueil" onClick={handleLinkClick}>
                Accueil
            </HashLink>

            {/* Dropdown Chiropraxie */}
            <div className="dropdown">
                <button
                    className="px-4 font-extrabold text-gray-700 lg:text-gray-300 hover:text-blue-900 lg:hover:text-white flex items-center gap-1 transition-colors duration-200"
                    onClick={() => toggleDropdown('chiropraxie')}
                >
                    Chiropraxie
                    <svg className={`w-4 h-4 transition-transform ${openDropdown === 'chiropraxie' ? 'rotate-180' : ''} lg:hidden`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                    <i className="fa fa-caret-down hidden lg:inline"></i>
                </button>
                {/* Desktop dropdown (hover) */}
                <div className="dropdown-content">
                    <HashLink className="px-4 py-2 block text-gray-500 hover:text-blue-900" smooth to="/Chiropraxie" onClick={handleLinkClick}>
                        Qu'est ce que la Chiropraxie ?
                    </HashLink>
                    <HashLink className="px-4 py-2 block text-gray-500 hover:text-blue-900" smooth to="/FormationChiropracteur" onClick={handleLinkClick}>
                        Formation du Chiropracteur
                    </HashLink>
                    <HashLink className="px-4 py-2 block text-gray-500 hover:text-blue-900" smooth to="/EfficaciteetSoins" onClick={handleLinkClick}>
                        Efficacité et bénéfices des soins
                    </HashLink>
                </div>
                {/* Mobile dropdown (click) */}
                <div className={`dropdown-content-mobile ${openDropdown === 'chiropraxie' ? 'show' : ''}`}>
                    <HashLink className="px-4 py-2 block text-gray-500 hover:text-blue-900" smooth to="/Chiropraxie" onClick={handleLinkClick}>
                        Qu'est ce que la Chiropraxie ?
                    </HashLink>
                    <HashLink className="px-4 py-2 block text-gray-500 hover:text-blue-900" smooth to="/FormationChiropracteur" onClick={handleLinkClick}>
                        Formation du Chiropracteur
                    </HashLink>
                    <HashLink className="px-4 py-2 block text-gray-500 hover:text-blue-900" smooth to="/EfficaciteetSoins" onClick={handleLinkClick}>
                        Efficacité et bénéfices des soins
                    </HashLink>
                </div>
            </div>

            {/* Dropdown Centre Chiropratique */}
            <div className="dropdown">
                <button
                    className="px-4 font-extrabold text-gray-700 lg:text-gray-300 hover:text-blue-900 lg:hover:text-white flex items-center gap-1 transition-colors duration-200"
                    onClick={() => toggleDropdown('centre')}
                >
                    <span className="text-center lg:text-left">Votre Centre</span>
                    <svg className={`w-4 h-4 transition-transform ${openDropdown === 'centre' ? 'rotate-180' : ''} lg:hidden`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                    <i className="fa fa-caret-down hidden lg:inline"></i>
                </button>
                {/* Desktop dropdown (hover) */}
                <div className="dropdown-content">
                    <HashLink className="px-4 py-2 block text-gray-500 hover:text-blue-900" smooth to="/ConsultationQui" onClick={handleLinkClick}>
                        Qui Peut Nous Consulter ?
                    </HashLink>
                    <HashLink className="px-4 py-2 block text-gray-500 hover:text-blue-900" smooth to="/ConsultationPourquoi" onClick={handleLinkClick}>
                        Pourquoi Consulter ?
                    </HashLink>
                    <HashLink className="px-4 py-2 block text-gray-500 hover:text-blue-900" smooth to="/Praticiens" onClick={handleLinkClick}>
                        Vos Chiropracteurs
                    </HashLink>
                    <HashLink className="px-4 py-2 block text-gray-500 hover:text-blue-900" smooth to="/DeroulementSoins" onClick={handleLinkClick}>
                        Déroulement des Soins
                    </HashLink>
                    <HashLink className="px-4 py-2 block text-gray-500 hover:text-blue-900" smooth to="/Tarifs" onClick={handleLinkClick}>
                        Tarifs et remboursements
                    </HashLink>
                </div>
                {/* Mobile dropdown (click) */}
                <div className={`dropdown-content-mobile ${openDropdown === 'centre' ? 'show' : ''}`}>
                    <HashLink className="px-4 py-2 block text-gray-500 hover:text-blue-900" smooth to="/ConsultationQui" onClick={handleLinkClick}>
                        Qui Peut Nous Consulter ?
                    </HashLink>
                    <HashLink className="px-4 py-2 block text-gray-500 hover:text-blue-900" smooth to="/ConsultationPourquoi" onClick={handleLinkClick}>
                        Pourquoi Consulter ?
                    </HashLink>
                    <HashLink className="px-4 py-2 block text-gray-500 hover:text-blue-900" smooth to="/Praticiens" onClick={handleLinkClick}>
                        Vos Chiropracteurs
                    </HashLink>
                    <HashLink className="px-4 py-2 block text-gray-500 hover:text-blue-900" smooth to="/DeroulementSoins" onClick={handleLinkClick}>
                        Déroulement des Soins
                    </HashLink>
                    <HashLink className="px-4 py-2 block text-gray-500 hover:text-blue-900" smooth to="/Tarifs" onClick={handleLinkClick}>
                        Tarifs et remboursements
                    </HashLink>
                </div>
            </div>

            <HashLink className={linkClass('/contact')} to="/contact#contact" onClick={handleLinkClick}>
                Contact
            </HashLink>
            <button
                style={{ background: Helper.contentLetterColor }}
                className="text-gray-900 inline-flex items-center justify-center w-full lg:w-auto px-4 lg:px-6 py-2 lg:py-3 shadow-xl rounded-xl text-sm lg:text-base font-bold hover:opacity-90 transition-opacity mt-2 lg:mt-0"
                onClick={() => { webSite(); handleLinkClick(); }}
                aria-label="Prendre rendez-vous en ligne"
            >
                Rendez-vous
            </button>
        </>
    )
}

export default NavLinks;
